export class Alert {
    public type: string;
    public message: string;

    public static success(message: string): Alert {
        let alert = new Alert();
        alert.type = "success";
        alert.message = message;

        return alert;
    }

    public static error(message: string): Alert {
        let alert = new Alert();
        alert.type = "danger";
        alert.message = message;

        return alert;
    }
}
